// Часовникът на СЪРВЪРА, погледнат от терминала: разликата „сървър − терминал".
// Нужна е навсякъде, където екранът брои до момент, който сървърът е решил —
// обедното меню изчезва в същата секунда, в която облакът спира да го приема,
// а задържаната поръчка („Задържи · 10 мин") показва колко остава до
// `hold_until`, сметнато по часовника на базата. С избързал или изостанал
// часовник на терминала и двете биха лъгали с толкова, колкото е разликата.
//
// Сверява се САМО по отговор от облака (`getMenu`/`getMenuState` в
// `api/menu.ts`); офлайн остава последната разлика — копието в касата носи
// времето, когато е записано.

let serverSkewMs = 0;

export const noteServerTime = (serverTime: string | null | undefined) => {
  const serverMs = serverTime ? Date.parse(serverTime) : Number.NaN;
  if (Number.isFinite(serverMs)) serverSkewMs = serverMs - Date.now();
};

/** Сега по часовника на сървъра, в милисекунди от епохата. */
export const serverNowMs = () => Date.now() + serverSkewMs;

/** Сега по часовника на сървъра. */
export const serverNow = () => new Date(serverNowMs());
